import { useState } from "react";

const createEmptyCoAuthor = () => ({
  name: "",
  email: "",
  phone: "",
  specialization: "",
  designation: "",
});

const validateCoAuthorEmail = (email) => {
  if (!email || email.trim() === "") return "";
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email) ? "" : "Invalid email format";
};

const validateCoAuthorPhone = (phone) => {
  if (!phone || phone.trim() === "") return "";
  const phoneRegex = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{1,9}$/;
  return phoneRegex.test(phone) ? "" : "Invalid phone number format";
};

export const useCoAuthors = () => {
  const [coAuthors, setCoAuthors] = useState([]);
  const [coAuthorErrors, setCoAuthorErrors] = useState([]);

  const handleAddCoAuthor = () => {
    setCoAuthors((currentCoAuthors) => [
      ...currentCoAuthors,
      createEmptyCoAuthor(),
    ]);
  };

  const handleAddValidatedCoAuthor = () => {
    handleAddCoAuthor();
    setCoAuthorErrors((currentErrors) => [
      ...currentErrors,
      { email: "", phone: "" },
    ]);
  };

  const handleUpdateCoAuthor = (index, field, value) => {
    setCoAuthors((currentCoAuthors) =>
      currentCoAuthors.map((coAuthor, currentIndex) =>
        currentIndex === index ? { ...coAuthor, [field]: value } : coAuthor
      )
    );
  };

  const handleUpdateValidatedCoAuthor = (index, field, value) => {
    handleUpdateCoAuthor(index, field, value);

    if (field === "email" || field === "phone") {
      setCoAuthorErrors((currentErrors) => {
        const nextErrors = [...currentErrors];
        nextErrors[index] = {
          email: "",
          phone: "",
          ...(nextErrors[index] || {}),
          [field]:
            field === "email"
              ? validateCoAuthorEmail(value)
              : validateCoAuthorPhone(value),
        };
        return nextErrors;
      });
    }
  };

  const handleRemoveCoAuthor = (index) => {
    setCoAuthors((currentCoAuthors) =>
      currentCoAuthors.filter((_, currentIndex) => currentIndex !== index)
    );
  };

  const handleRemoveValidatedCoAuthor = (index) => {
    handleRemoveCoAuthor(index);
    setCoAuthorErrors((currentErrors) =>
      currentErrors.filter((_, currentIndex) => currentIndex !== index)
    );
  };

  return {
    coAuthors,
    setCoAuthors,
    coAuthorErrors,
    setCoAuthorErrors,
    handleAddCoAuthor,
    handleAddValidatedCoAuthor,
    handleUpdateCoAuthor,
    handleUpdateValidatedCoAuthor,
    handleRemoveCoAuthor,
    handleRemoveValidatedCoAuthor,
  };
};
